import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class JsonDateInterceptor implements HttpInterceptor {
  // eslint-disable-next-line no-useless-escape
  private readonly dateFormat = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(response => {
        if (response instanceof HttpResponse) {
          const responseBody = response.body;
          this.convertToDate(responseBody);
        }
        return response;
      })
    );
  }

  isDate(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      return this.dateFormat.test(value);
    }
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  convertToDate(body: any) {
    if (body != null && typeof body === 'object') {
      for (const prop of Object.keys(body)) {
        const value = body[prop];
        if (this.isDate(value)) {
          const dnStartDate = new Date(value);
          body[prop] = new Date(dnStartDate.getUTCFullYear(), dnStartDate.getUTCMonth(), dnStartDate.getUTCDate());
        } else if (typeof value === 'object') {
          this.convertToDate(value);
        }
      }
    }
    return body;
  }
}
